module.exports = __webpack_public_path__ + "img/maskmakers.c4dd0e1f.svg";